import { addZero } from "@api";

/** Returns an ISO string for the calendar date to avoid wrong timezone shift when calling the backend.
 * @example useGetCandidateMailPreview()
 */
export const toCalendarDateUTC = (date: Date): string => {
  const y = date.getFullYear();
  const m = addZero(date.getMonth() + 1);
  const d = addZero(date.getDate());
  return `${y}-${m}-${d}T00:00:00.000Z`;
};
